const config = {

  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/", // local,
  
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

const token = localStorage.getItem("jwt-token");
if (token) {
  config.headers.authorization = `Bearer ${token}`;
}

export default config;
